module.exports = __webpack_public_path__ + "static/media/taiwan-flag.5d895aaf.png";